// redex/users/reportApi.js
import api from "../../utils/api";
import { apiPath } from "../../utils/apiPath";
import { showApiErrorToast } from "../../utils/toastErrorHandler";


export async function deployementsListsApi(payload) {
  return await api.get(
    `${apiPath.API_URL}${apiPath.deployements.deployementsList}`,
    { params: payload } 
  );
}
